import React from 'react'
import { Form } from 'react-bootstrap'

export default ({ maxLength, pattern, title, format, text, name, onChange, require, value, disabled, placeholder=name, required=false, ...props}) => {
  const className = required ? "text-grey font-weight-bold medium required" : "text-grey font-weight-bold medium";
  return (
    <>
      <Form.Group controlId={name}>
        <Form.Label className={className}>{text}</Form.Label>
        <Form.Control 
          maxLength={maxLength}
          pattern={pattern}
          title={title}
          name={name} 
          disabled={disabled} 
          value={value} 
          onChange={({ target }) => onChange(target.name, target.value, format)} 
          placeholder={"Enter " + placeholder} 
          required={required} />
      </Form.Group>
    </>
  )
}
